module.exports = __webpack_public_path__ + "img/89823918000225.95f131e6.png";